export default {
    all: (state) => {
        return Object.entries(state).map(x => { return { name: x[0], value: x[1] } })
    },
    get: (state) => (mode) => {
        // turn everything off if show
        if (mode == 'testing') return state['show']
        return state['show'] ? state[mode] : false
    }
}
